import { createReporter } from "@brouhaha/errors";

/**
 * Errors from the phone go to Sentry when the build has a DSN
 * (VITE_SENTRY_DSN). About a kilobyte, no SDK, so the scan route pays
 * nothing it cannot afford. Tags are set by the screen that knows them.
 */
export const errors = createReporter({
  dsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) || undefined,
  service: "web",
  environment: import.meta.env.MODE,
  fetch: (...args) => fetch(...args),
});

let tags: Record<string, string | null> = {};

/** The lobby and game the phone is in, for every report that follows. */
export function setErrorTags(next: Record<string, string | null>): void {
  tags = { ...tags, ...next };
}

export function reportError(error: unknown, extra?: Record<string, unknown>): void {
  void errors.report(error, { tags, ...(extra ? { extra } : {}) });
}

/** Window-level catches: anything React, the router or a promise let through. */
export function installErrorReporting(): void {
  if (!errors.enabled) return;
  window.addEventListener("error", (e) => reportError(e.error ?? e.message, { source: "window" }));
  window.addEventListener("unhandledrejection", (e) =>
    reportError(e.reason, { source: "promise" }),
  );
}
